import * as common from './common';
import * as components from './components';
import * as pages from './pages';
import * as enums from './enums';
import * as teethConditions from './teethConditions';
import * as finance from './finance';
import * as laboratoryModule from './LaboratoryModule';
import * as scheduleModule from './ScheduleModule';
import * as planModule from './PlanModule';
import * as dashboardModule from './DasboardModule';
import * as organizationModule from './OrganizationModule';
import * as templateModule from './TemplateModule';
import * as serviceModule from './ServiceModule';
import * as incuranceModule from './IncuranceModule';
import * as billingMachine from './billingMachine';
import * as supportWidget from './supportWidget';
export const allTranslations = {
    ...common,
    ...components,
    ...pages,
    ...enums,
    ...finance,
    ...laboratoryModule,
    ...scheduleModule,
    ...planModule,
    ...dashboardModule,
    ...organizationModule,
    ...templateModule,
    ...serviceModule,
    ...incuranceModule,
    ...teethConditions,
    ...billingMachine,
    ...supportWidget,
};
